// Loader.js
import React from "react";
import "./Loader.css"; // You can create a separate CSS file for styling

const Loader = () => {
  return (
    <div className="d-flex justify-content-center">
      <div className="spinner-border text-orange" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
